var classnames = {exports: {}};

export { classnames as __module };
//# sourceMappingURL=index.js.map
